import { Button, ButtonText } from '@/components/ui/button'
import { Center } from '@/components/ui/center'
import { Text } from '@/components/ui/text'
import { VStack } from '@/components/ui/vstack'
import { redirectAutoLogout, removeAuthToken } from '@/lib/api/authToken'
import usePlatformColor from '@/lib/hooks/usePlatformColor'
import { resetCurrentUser } from '@/redux/slices/currentUserSlice'
import { logoutThunk } from '@/redux/slices/sessionSlice'
import { useAppDispatch } from '@/redux/store'
import { useRouter } from 'expo-router'
import { TriangleAlertIcon } from 'lucide-react-native'
import { Platform, View } from 'react-native'

export default function AuthErrorNotice() {
  const router = useRouter()
  const dispatch = useAppDispatch()
  const [systemOrange, secondaryLabel] = usePlatformColor('systemOrange', 'secondaryLabel')

  const handleButtonPress = () => {
    dispatch(resetCurrentUser())
    if (Platform.OS === 'web') {
      removeAuthToken()
      redirectAutoLogout()
      return
    }
    dispatch(logoutThunk())
    router.replace('/login')
  }

  return (
    <Center className="flex-1 px-10">
      <VStack space="md" className="items-center">
        <View className="w-20 h-20 rounded-full bg-orange-100 dark:bg-orange-900/30 items-center justify-center mb-2">
          <TriangleAlertIcon size={40} color={systemOrange as string} />
        </View>
        <Text size="xl" className="font-semibold">
          登录已过期
        </Text>
        <Text size="md" style={{ color: secondaryLabel }} className="text-center">
          当前登录信息已过期，请重新登录
        </Text>
      </VStack>
      <Button size="lg" className="w-full max-w-sm mt-10" onPress={handleButtonPress}>
        <ButtonText>重新登录</ButtonText>
      </Button>
    </Center>
  )
}
